import { render, staticRenderFns } from "./teaser.vue?vue&type=template&id=e287a456&scoped=true&"
import script from "./teaser.vue?vue&type=script&lang=js&"
export * from "./teaser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e287a456",
  null
  
)

export default component.exports